import { arbitrumSepolia } from "wagmi/chains"

export const SOURCE_CHAIN_RPC_URL =
  process.env.NEXT_PUBLIC_SOURCE_CHAIN_RPC ?? ""

// Use arbitrumSepolia as-is for chain metadata (MetaMask needs its public RPCs
// to add/switch chain). The custom Chainstack RPC is only used via wagmi transport.
export const sourceChain = arbitrumSepolia
